import React, { useEffect, useState } from "react";
import { Modal, Table, TreeSelect } from "antd";
import { useDebounce } from "use-debounce";
import CustomButton from "../../../components/CustomButton";
import CustomInput from "../../../components/CustomInput";
import DeleteIcon from "../../../components/Icons/delete.svg";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
    getPtmByIds,
    getTreeAction,
    clearAction,
} from "../../NRI/RePTMs/store/actions";
import Notifications from "../../../helpers/Notifications";

const AddPtmDescription = ({ descriptions, setDescriptions }) => {
    const [visible, setVisible] = useState(false);
    const [searchPTMs, setSearchPTMs] = useState(null);
    const [selectedPtm, setSelectedPtm] = useState([]);

    const { tree, list } = useSelector((state) => state.rePtmReducer);
    const [PTM] = useDebounce(searchPTMs, 500);

    const { t } = useTranslation(["common", "action", "project"]);
    const dispatch = useDispatch();

    const getByIds = (values) => {
        if (selectedPtm.length > 0) {
            dispatch(getPtmByIds(values));
        }
    };

    const getTree = (values) => {
        dispatch(getTreeAction(values));
    };

    useEffect(() => {
        return () => {
            dispatch(clearAction());
        };
    }, []);

    useEffect(() => {
        getTree({ name: PTM?.trim(), level: 2 });
    }, [PTM]);
    
    useEffect(() => {
        let ptms = list ? [...list, ...findParents(list)] : [];

        ptms = ptms?.map((p) => {
            const previousDescription = descriptions.find(
                ({ id }) => id == p.id
            );
            return {
                ...p,
                ptmId: p.id,
                description: previousDescription?.description ?? "",
            };
        });

        const sortedPtms = ptms.sort((a, b) => a.code.localeCompare(b.code));

        setDescriptions(sortedPtms);
    }, [list]);

    const showPTM = () => {
        if(selectedPtm.length){
            getByIds({ ids: selectedPtm });
            setVisible(false);
        } else {
            Notifications.errorNotice(`${t('action:choose')} ${t('common:ptm')}`, null, 20)
        }
    };

    const findParents = (ptms) => {
        let parents = ptms?.flatMap((ptm, _, arr) => {
            if (arr.find((p) => p.id == ptm.parentId)) {
                return [];
            }

            const parent = tree.find((t) => t.id == ptm.parentId);
            if (parent)
                return {
                    id: parent.id,
                    code: parent.code,
                    name: parent.name,
                    isParent: parent.parent.id === null,
                };
            return [];
        });

        parents = [...new Map(parents.map((item) => [item.id, item])).values()]; //remove duplicate
        return parents;
    };

    const deleteHandler = (ptmId) => {
        const ptm = descriptions.find(d => d.id == ptmId)
        const isLastChild = descriptions.filter(d => d.parentId == ptm.parentId).length == 1;
        
        setSelectedPtm(selectedPtm.filter((d) => d != ptmId));
        setDescriptions(descriptions.filter((d) => d.ptmId != ptmId && (isLastChild ? d.id != ptm.parentId : true)));
    };

    const columns = [
        {
            title: t("code"),
            dataIndex: "code",
            key: "code",
            width: "10%",
        },
        {
            title: t("title"),
            dataIndex: "name",
            key: "name",
            width: "25%",
        },
        {
            title: `${t("project:description")} ${t("ptm")}`,
            dataIndex: "id",
            key: "ptmDescription",
            render: (ptmId, ptm) => !ptm.isParent && (
                    <CustomInput
                        type="textarea"
                        allowClear
                        placeholder={`${t("action:enter")} ${t("project:description").toLocaleLowerCase()} ${t("ptm")}`}
                        onChange={(e) => {
                            setDescriptions(
                                descriptions.map((d) =>
                                    d.ptmId === ptmId
                                        ? {
                                              ...d,
                                              description:
                                                  e.target.value.trim(),
                                          }
                                        : d
                                )
                            );
                        }}
                    />
                )
        },
        {
            dataIndex: "id",
            key: "id",
            width: "3%",
            render: (ptmId, ptm) => !ptm.isParent && (
                <img alt=""
                    src={DeleteIcon}
                    className="delete-icon"
                    title={t("action:delete")}
                    onClick={() => deleteHandler(ptmId)}
                />
            ),
        },
    ];

    return (
        <div className="main-form ptm-description">
            <div className="manage">
                <CustomButton
                    type="green"
                    className="add-btn"
                    onClick={() => {
                        setVisible(true);
                    }}
                >
                    <div>                        
                        <span>{`${t("project:addPtmDescription")}`}</span>
                    </div>
                </CustomButton>
            </div>
            <Table
                columns={columns}
                dataSource={descriptions}
                rowKey={(item) => item.id}
                rowClassName={(record) =>
                    record?.isParent ? "description-group-title" : ""
                }
                pagination={false}
                scroll={{ x: 1100, y: 700 }}
            />
            <Modal
                footer={[
                    <CustomButton
                        type="green"
                        key="appleDesc"
                        onClick={showPTM}
                    >
                        {t("apply")}
                    </CustomButton>,
                ]}
                onCancel={showPTM}
                title={`${t("project:addPtmDescription")}`}
                open={visible}
                width={900}
            >
                {tree && (
                    <TreeSelect
                        allowClear
                        multiple
                        treeCheckable
                        showCheckedStrategy="SHOW_CHILD"
                        placeholder={`${t("action:choose")} ${t("ptm")}`}
                        treeData={tree}
                        value={selectedPtm}
                        fieldNames={{
                            label: "name",
                            value: "id",
                            key: "id",
                            children: "children",
                        }}
                        style={{ width: "100%" }}
                        height={600}
                        onChange={(keys) => setSelectedPtm(keys)}
                        onSearch={(name) => setSearchPTMs(name)}
                    />
                )}
            </Modal>
        </div>
    );
};
export default AddPtmDescription;
